import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import {
  AR_CONTENT_TAB,
  RESOURCE_APPLICATION_TAB,
  RESOURCE_ENVIRONMENT_TAB,
  RESOURCE_MODULE_TAB,
  RESOURCE_SKILL_SCHOOL_TAB,
  RESOURCE_SKILL_STREAM_TAB,
} from "../../../constant/constants";
import { checkPermissionExist, toggleArrayByObject, visibleAssignSection } from "../../../utils/general";
import ApplicationTabSlider from "./ApplicationTabSlider";
import ApplicationsList from "../../../pages/TeamManagement/SliderTabs/Applications";
import ModulesList from "../../../pages/TeamManagement/SliderTabs/Modules";
import { RESOURCE_REVOKE_PERMISSION } from "../../../constant/permission";

const ApplicationTab = ({
  renderList,
  hasMore,
  loading,
  handlePaginationLoadMoreData,
  defaultTab,
  setDefaultTab,
  setSelectedItems,
  selectedItems,
  isMobileView,
}) => {

  const [resourceItems, setResourceItems] = useState([]);
  const filterOptions = useSelector(state => state.filterOptions)

  const handleSelectItems = (data) => {
    setSelectedItems((pre) => ({ ...pre, [defaultTab]: toggleArrayByObject(pre[defaultTab] || [], data) }));
  };

   useEffect(() => {
      setResourceItems(visibleAssignSection(filterOptions.total))
    }, [filterOptions]);
  

  const handleAppClick = (uuid) => {
    console.log("clicked on app");
  };

  const renderTabContent = () => {
    switch (defaultTab) {
      case RESOURCE_APPLICATION_TAB:
        return (
          <ApplicationsList
            list={renderList}
            handleSelectItems={handleSelectItems}
            selectedItems={selectedItems[RESOURCE_APPLICATION_TAB] || []}
            handleAppClick={handleAppClick}
            type={RESOURCE_APPLICATION_TAB}
            loading={loading}
            hasMore={hasMore}
            showCheckbox={checkPermissionExist(RESOURCE_REVOKE_PERMISSION)}
            loadMoreData={() => handlePaginationLoadMoreData(RESOURCE_APPLICATION_TAB)}
            isMobileView={isMobileView}
          />
        );
      case RESOURCE_MODULE_TAB:
        return (
          <ModulesList
            list={renderList}
            handleSelectItems={handleSelectItems}
            selectedItems={selectedItems[RESOURCE_MODULE_TAB] || []}
            type={RESOURCE_MODULE_TAB}
            handleAppClick={handleAppClick}
            hasMore={hasMore}
            loadMoreData={() => handlePaginationLoadMoreData(RESOURCE_MODULE_TAB)}
            loading={loading}
            showCheckbox={checkPermissionExist(RESOURCE_REVOKE_PERMISSION)}
            isMobileView={isMobileView}
          />
        );
      case RESOURCE_ENVIRONMENT_TAB:
        return (
          <ModulesList
            loading={loading}
            list={renderList}
            handleSelectItems={handleSelectItems}
            selectedItems={selectedItems[RESOURCE_ENVIRONMENT_TAB] || []}
            type={RESOURCE_ENVIRONMENT_TAB}
            handleAppClick={handleAppClick}
            hasMore={hasMore}
            loadMoreData={() => handlePaginationLoadMoreData(RESOURCE_ENVIRONMENT_TAB)}
            showCheckbox={checkPermissionExist(RESOURCE_REVOKE_PERMISSION)}
            isMobileView={isMobileView}
          />
        );
      case RESOURCE_SKILL_STREAM_TAB:
        return (
          <ModulesList
            list={renderList}
            handleSelectItems={handleSelectItems}
            selectedItems={selectedItems[RESOURCE_SKILL_STREAM_TAB] || []}
            type={RESOURCE_SKILL_STREAM_TAB}
            handleAppClick={handleAppClick}
            hasMore={hasMore}
            loadMoreData={() => handlePaginationLoadMoreData(RESOURCE_SKILL_STREAM_TAB)}
            loading={loading}
            showCheckbox={checkPermissionExist(RESOURCE_REVOKE_PERMISSION)}
            isMobileView={isMobileView}
          />
        );
      case RESOURCE_SKILL_SCHOOL_TAB:
        return (
          <ModulesList
            list={renderList}
            handleSelectItems={handleSelectItems}
            selectedItems={selectedItems[RESOURCE_SKILL_SCHOOL_TAB] || []}
            type={RESOURCE_SKILL_SCHOOL_TAB}
            handleAppClick={handleAppClick}
            hasMore={hasMore}
            loadMoreData={() => handlePaginationLoadMoreData(RESOURCE_SKILL_SCHOOL_TAB)}
            loading={loading}
            showCheckbox={checkPermissionExist(RESOURCE_REVOKE_PERMISSION)}
            isMobileView={isMobileView}
          />
        );
      case AR_CONTENT_TAB:
        return (
          <ModulesList
            list={renderList}
            handleSelectItems={handleSelectItems}
            selectedItems={selectedItems[AR_CONTENT_TAB] || []}
            type={AR_CONTENT_TAB}
            handleAppClick={handleAppClick}
            hasMore={hasMore}
            loadMoreData={() => handlePaginationLoadMoreData(AR_CONTENT_TAB)}
            loading={loading}
            showCheckbox={checkPermissionExist(RESOURCE_REVOKE_PERMISSION)}
            isMobileView={isMobileView}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div className="slider-container">
        <ApplicationTabSlider
          applicationTabsList={resourceItems}
          defaultTab={defaultTab}
          setDefaultTab={setDefaultTab}
        />
      </div>

      {renderTabContent()}
    </>

  );
};

export default ApplicationTab;
